import PlaceCode from "pages/AtPort/DandoriWorks";
import CreatePlaceCode from "pages/AtPort/DandoriWorks/CreatePlaceCode";
import EditPlaceCode from "pages/AtPort/DandoriWorks/EditPlaceCode";
import ImportUser from "pages/AtPort/ImportUser";
import SystemNotification from "pages/AtPort/SystemNotification";
import CreateSystemNotification from "pages/AtPort/SystemNotification/CreateNotification";
import EditSystemNotification from "pages/AtPort/SystemNotification/EditNotification";
import User from "pages/AtPort/User";
import EditUser from "pages/AtPort/User/EditUser";

const AtPort = {
  User,
  EditUser,
  PlaceCode,
  CreatePlaceCode,
  EditPlaceCode,
  ImportUser,
  SystemNotification,
  EditSystemNotification,
  CreateSystemNotification,
};

export default AtPort;
